import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HomepageLayoutComponent } from './homepage-layout/homepage-layout.component';
import { AboutInstituteComponent } from './about-institute/about-institute.component';
import { AboutRgiComponent } from './about-rgi/about-rgi.component';
import { VisionMissionComponent } from './vision-mission/vision-mission.component';
import { ChairmansMessageComponent } from './chairmans-message/chairmans-message.component';
import { PrincipleMessageComponent } from './principle-message/principle-message.component';
import { CoreValueComponent } from './core-value/core-value.component';
import { CodeOfConductComponent } from './code-of-conduct/code-of-conduct.component';
import { GoverningBodyComponent } from './governing-body/governing-body.component';
import { AdmissionOverviewComponent } from './admission-overview/admission-overview.component';
import { StudentScholarshipComponent } from './student-scholarship/student-scholarship.component';
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component';
import { AdmissionHelplineComponent } from './admission-helpline/admission-helpline.component';
import { FaqComponent } from './faq/faq.component';
import { FeesStructureComponent } from './fees-structure/fees-structure.component';
import { OnlineFeesPaymentComponent } from './online-fees-payment/online-fees-payment.component';
import { UgBachelorOfBusinessAdministrationComputerApplicationComponent } from './ug-bachelor-of-business-administration-computer-application/ug-bachelor-of-business-administration-computer-application.component';
import { UgBachelorOfBusinessAdministrationComponent } from './ug-bachelor-of-business-administration/ug-bachelor-of-business-administration.component';
import { UgBachelorOfScienceComputerSciencenComponent } from './ug-bachelor-of-science-computer-sciencen/ug-bachelor-of-science-computer-sciencen.component';
import { UgBachelorOfCommerceComponent } from './ug-bachelor-of-commerce/ug-bachelor-of-commerce.component';
import { UgBachelorOfArtsComponent } from './ug-bachelor-of-arts/ug-bachelor-of-arts.component';
import { UgBachelorOfScienceComponent } from './ug-bachelor-of-science/ug-bachelor-of-science.component';
import { UgBachelorOfScienceHospitalityStudiesComponent } from './ug-bachelor-of-science-hospitality-studies/ug-bachelor-of-science-hospitality-studies.component';
import { PgMastersOfScienceComputerScienceComponent } from './pg-masters-of-science-computer-science/pg-masters-of-science-computer-science.component';
import { PgMastersOfCommerceComponent } from './pg-masters-of-commerce/pg-masters-of-commerce.component';
import { AcademicCalenderComponent } from './academic-calender/academic-calender.component';
import { CodeOfEthicsComponent } from './code-of-ethics/code-of-ethics.component';
import { FeedbackProcessComponent } from './feedback-process/feedback-process.component';
import { StudentProjectsComponent } from './student-projects/student-projects.component';
import { QuestionPaperComponent } from './question-paper/question-paper.component';
import { GrievanceRegistrationFormComponent } from './grievance-registration-form/grievance-registration-form.component';
import { MinorityCellCommitteeComponent } from './minority-cell-committee/minority-cell-committee.component';
import { AntiRaggingCommitteeComponent } from './anti-ragging-committee/anti-ragging-committee.component';
import { CollegeDevelopmentCommitteeComponent } from './college-development-committee/college-development-committee.component';
import { GrievanceRedressalCommitteeComponent } from './grievance-redressal-committee/grievance-redressal-committee.component';
import { ExamGrievanceRedressalCommitteeComponent } from './exam-grievance-redressal-committee/exam-grievance-redressal-committee.component';
import { NssCommitteeComponent } from './nss-committee/nss-committee.component';
import { NaacCommitteeComponent } from './naac-committee/naac-committee.component';
import { ObcCellCommitteeComponent } from './obc-cell-committee/obc-cell-committee.component';
import { ScStCommitteeComponent } from './sc-st-committee/sc-st-committee.component';
import { SportsCulturalCommitteeComponent } from './sports-cultural-committee/sports-cultural-committee.component';
import { StudentCouncilCommitteeComponent } from './student-council-committee/student-council-committee.component';
import { TrainingPlacementCommitteeComponent } from './training-placement-committee/training-placement-committee.component';
import { WomensGrievanceRedressalCommitteeComponent } from './womens-grievance-redressal-committee/womens-grievance-redressal-committee.component';
import { PlacementProcessComponent } from './placement-process/placement-process.component';
import { PlacementTeamComponent } from './placement-team/placement-team.component';
import { InternshipComponent } from './internship/internship.component';
import { PastRecruitersComponent } from './past-recruiters/past-recruiters.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { RocsComponent } from './rocs/rocs.component';
import { AboutIqacComponent } from './about-iqac/about-iqac.component';
import { ObjectivesComponent } from './objectives/objectives.component';
import { FunctionsComponent } from './functions/functions.component';
import { IqacMembersComponent } from './iqac-members/iqac-members.component';
import { MinutesOfMeetingComponent } from './minutes-of-meeting/minutes-of-meeting.component';
import { AtrComponent } from './atr/atr.component';
import { DocumentsComponent } from './documents/documents.component';
import { NaacComponent } from './naac/naac.component';
import { PoCoComponent } from './po-co/po-co.component';
import { CourseOutcomesComponent } from './course-outcomes/course-outcomes.component';
import { HostelComponent } from './hostel/hostel.component';
import { StudentLifeComponent } from './student-life/student-life.component';
import { EventsComponent } from './events/events.component';
import { AtheleticsSportsComponent } from './atheletics-sports/atheletics-sports.component';
import { LibraryComponent } from './library/library.component';
import { LabsComponent } from './labs/labs.component';
import { CityOfficeComponent } from './city-office/city-office.component';
import { ContactComponent } from './contact/contact.component';
import { KimbaComponent } from './kimba/kimba.component';
import { AqarComponent } from './aqar/aqar.component';
import { IctToolsComponent } from './ict-tools/ict-tools.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { LoginComponent } from './login/login.component';
import { OnlineAntiRaggingAffidavitsComponent } from './online-anti-ragging-affidavits/online-anti-ragging-affidavits.component';
import { BbaEntranceComponent } from './bba-entrance/bba-entrance.component';
import { ExamGrievanceComponent } from './exam-grievance/exam-grievance.component';
import { AdmissionCellCommitteeComponent } from './admission-cell-committee/admission-cell-committee.component';
import { PlanningEvaluationCommitteeComponent } from './planning-evaluation-committee/planning-evaluation-committee.component';
import { AcademicMonitoringDisciplineCommitteeComponent } from './academic-monitoring-discipline-committee/academic-monitoring-discipline-committee.component';
import { ExaminationCommitteeComponent } from './examination-committee/examination-committee.component';
import { ResearchDevelopmentCommitteeComponent } from './research-development-committee/research-development-committee.component';
import { BuildingMaintenancePurchaseCommitteeComponent } from './building-maintenance-purchase-committee/building-maintenance-purchase-committee.component';
import { BlogComponent } from './blog/blog.component';
import { WhyAnBBAIsBestSuitedForYouComponent } from './why-an-bba-is-best-suited-for-you/why-an-bba-is-best-suited-for-you.component';
import { WhyBscComputerScienceIsTheBestOrientedCourseComponent } from './why-bsc-computer-science-is-the-best-oriented-course/why-bsc-computer-science-is-the-best-oriented-course.component';
import { HowToGetAdmissionToBcomComponent } from './how-to-get-admission-to-bcom/how-to-get-admission-to-bcom.component';
import { WhyDidWeChooseBbaInComputerApplicationsComponent } from './why-did-we-choose-bba-in-computer-applications/why-did-we-choose-bba-in-computer-applications.component';
import { TwentyOneComponent } from './aqar-tweety/twenty-one/twenty-one.component';
import { BScInComputerScienceComponent } from './b-sc-in-computer-science/b-sc-in-computer-science.component';
import { BachelorOfCommerceDegreeComponent } from './bachelor-of-commerce-degree/bachelor-of-commerce-degree.component';
import { BachelorsDegreeInBusinessAdministrationComponent } from './bachelors-degree-in-business-administration/bachelors-degree-in-business-administration.component';
import { BachelorOfCommerceDegreeAComprehensiveGuideComponent } from './bachelor-of-commerce-degree-a-comprehensive-guide/bachelor-of-commerce-degree-a-comprehensive-guide.component';
import { BachelorOfBusinessAdministrationProgramComponent } from './bachelor-of-business-administration-program/bachelor-of-business-administration-program.component';
import { BachelorOfBusinessAdministrationDegreeComponent } from './bachelor-of-business-administration-degree/bachelor-of-business-administration-degree.component';
import { WhyChooseABachelorOfCommerceComponent } from './why-choose-a-bachelor-of-commerce/why-choose-a-bachelor-of-commerce.component';
import { BachelorsDegreeAfterTwelveCommerceComponent } from './bachelors-degree-after-twelve-commerce/bachelors-degree-after-twelve-commerce.component';
import { BbaComputerApplicationsComponent } from './bba-computer-applications/bba-computer-applications.component';
import { BachelorOfBusinessDegreeComponent } from './bachelor-of-business-degree/bachelor-of-business-degree.component';
import { BachelorDegreeComponent } from './bachelor-degree/bachelor-degree.component';
import { TipsForCommerceStudentsPursuingABComDegreeComponent } from './tips-for-commerce-students-pursuing-a-b-com-degree/tips-for-commerce-students-pursuing-a-b-com-degree.component';
import { WhyPursueBachelorOfComputerApplicationComponent } from './why-pursue-bachelor-of-computer-application/why-pursue-bachelor-of-computer-application.component';
import { ScopeOfBbaComponent } from './scope-of-bba/scope-of-bba.component';
import { BscComputerScienceCourseComponent } from './bsc-computer-science-course/bsc-computer-science-course.component';
import { TipsForBscComputerScienceStudentComponent } from './tips-for-bsc-computer-science-student/tips-for-bsc-computer-science-student.component';
import { AdvantagesOfBbaDegreeComponent } from './advantages-of-bba-degree/advantages-of-bba-degree.component';
import { BbaInComputerApplicationComponent } from './bba-in-computer-application/bba-in-computer-application.component';
import { BestBbaCoursesComponent } from './best-bba-courses/best-bba-courses.component';
import { TopUniversitiesForBbaProgramsComponent } from './top-universities-for-bba-programs/top-universities-for-bba-programs.component';
import { CareerOptionsAfterBachelorOfCommerceComponent } from './career-options-after-bachelor-of-commerce/career-options-after-bachelor-of-commerce.component';
import { BbaInComputerApllicationsComponent } from './bba-in-computer-apllications/bba-in-computer-apllications.component';
import { MComComponent } from './m-com/m-com.component';
import { PgMscComponent } from './pg-msc/pg-msc.component';
import { TwentytwoTwentythreeComponent } from './twentytwo-twentythree/twentytwo-twentythree.component';
import { BscItComponent } from './bsc-it/bsc-it.component';
import { BbaInternationalBusinessComponent } from './bba-international-business/bba-international-business.component';
import { MscComputerScienceComponent } from './msc-computer-science/msc-computer-science.component';
import { BscComputerAplicationComponent } from './bsc-computer-aplication/bsc-computer-aplication.component';
import { RecrutersCourseComponent } from './recruters-course/recruters-course.component';
import { DirectorMessageComponent } from './director-message/director-message.component';
import { ExamCircularsComponent } from './exam-circulars/exam-circulars.component';
import { LatestNewsComponent } from './latest-news/latest-news.component';
import { TwentythreeTwentyfourComponent } from './twentythree-twentyfour/twentythree-twentyfour.component';
import { DivyangCommitteeComponent } from './divyang-committee/divyang-committee.component';
import { StudentsAchievementComponent } from './students-achievement/students-achievement.component';
import { PopupModalComponent } from './popup-modal/popup-modal.component';
import { WomenEmpowermentComponent } from './women-empowerment/women-empowerment.component';
import { GuruPurnimaComponent } from './guru-purnima/guru-purnima.component';
import { AshadhiEkadashiComponent } from './ashadhi-ekadashi/ashadhi-ekadashi.component';
import { SanskrutikMohotsavComponent } from './sanskrutik-mohotsav/sanskrutik-mohotsav.component';
import { ShivajiMaharajJayantiComponent } from './shivaji-maharaj-jayanti/shivaji-maharaj-jayanti.component';
import { MarathiRajbhashaComponent } from './marathi-rajbhasha/marathi-rajbhasha.component';
import { MahaparinirvanDiwasComponent } from './mahaparinirvan-diwas/mahaparinirvan-diwas.component';
import { AntaragniComponent } from './antaragni/antaragni.component';
import { AnnualPrizeDistributionComponent } from './annual-prize-distribution/annual-prize-distribution.component';
import { PunyatithiOfAnnabhauSatheComponent } from './punyatithi-of-annabhau-sathe/punyatithi-of-annabhau-sathe.component';
import { InductionProgramComponent } from './induction-program/induction-program.component';
import { FoundersDayComponent } from './founders-day/founders-day.component';
import { CelebratingYogaDayComponent } from './celebrating-yoga-day/celebrating-yoga-day.component';
import { NssCampComponent } from './nss-camp/nss-camp.component';
import { GbMeetingComponent } from './gb-meeting/gb-meeting.component';
import { ScienceDayComponent } from './science-day/science-day.component';
import { CoderushComponent } from './coderush/coderush.component';
import { IndustryConnectComponent } from './industry-connect/industry-connect.component';
import { BusinessExpoComponent } from './business-expo/business-expo.component';
import { CynosureToastmastersComponent } from './cynosure-toastmasters/cynosure-toastmasters.component';
import { GuestLecturerComponent } from './guest-lecturer/guest-lecturer.component';
import { DigitalMarketingWorkshopComponent } from './digital-marketing-workshop/digital-marketing-workshop.component';
import { AntiRaggingEventComponent } from './anti-ragging-event/anti-ragging-event.component';
import { UgProgramsComponent } from './ug-programs/ug-programs.component';
import { PgProgramsComponent } from './pg-programs/pg-programs.component';
import { EligibilityIntakeComponent } from './eligibility-intake/eligibility-intake.component';
import { FarewellPartyComponent } from './farewell-party/farewell-party.component';

const routes: Routes = [
  {
    path: '',
    component: HomepageLayoutComponent,
    children: [
      {
        path: '', component: HomeComponent,
        data: {
          description: 'The best College for arts, Commerce and science in Pune. Join GHRCACS Pune for cutting-edge education and innovation.',
          title: 'Best College in Pune | GHRCACS Pune'
        }
      },
      {
        path: 'about-institute', component: AboutInstituteComponent, pathMatch: 'full',
        data: {
          description: 'Discover excellence at GHRCACS! Our institute blends innovation with tradition, shaping future leaders. Learn more.',
          title: 'About Institute | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'about-rgi', component: AboutRgiComponent,
        data: {
          description: 'Discover excellence in education with Raisoni Group of Institutions! Empowering future leaders with innovation and knowledge.',
          title: 'About RGI | Raisoni College | GHRCACS Pune'
        }
      },
      {
        path: 'vision-mission', component: VisionMissionComponent,
        data: {
          description: 'Explore our vision and mission at GHRCACS! We are dedicated to excellence in education, innovation, and empowering future leaders.',
          title: 'Vision Mission | Best College of Art, Commerce and Science'
        }
      },
      {
        path: 'chairmans-message', component: ChairmansMessageComponent,
        data: {
          description: 'Discover the vision behind GH Raisoni College from our Chairman’s message. Inspiring education, innovation, and excellence.',
          title: 'Chairmans Message | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'principle-message', component: PrincipleMessageComponent,
        data: {
          description: 'Embrace excellence in education with us! Read our Principals inspiring message at GH Raisoni College of Arts, Commerce, and Science.',
          title: 'Principle Message | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'core-value', component: CoreValueComponent,
        data: {
          description: 'Empowering minds with integrity, excellence, and innovation. Discover the core values that shape our future at GH Raisoni College.',
          title: 'Core Value | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'code-of-conduct', component: CodeOfConductComponent,
        data: {
          description: 'Discover our commitment to integrity and excellence in education through our Code of Conduct. Explore more at GHRCACS.',
          title: 'Code of Conduct | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'governing-body', component: GoverningBodyComponent,
        data: {
          description: 'Meet the guiding force behind GH Raisoni College of Arts, Commerce & Science, Pune! Our Governing Body ensures excellence in education and growth',
          title: 'Governing Body | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'admission-overview', component: AdmissionOverviewComponent,
        data: {
          description: 'Unlock your future at GH Raisoni College of Arts, Commerce & Science! Explore our diverse programs & seamless admission process. Join us today!',
          title: 'Admisson Overview | Best College in Pune | GHRCACS, PUNE'
        }
      },
      {
        path: 'student-scholarship', component: StudentScholarshipComponent,
        data: {
          description: 'Unlock your potential with our student scholarships at GH Raisoni College of Arts, Commerce, and Science! Visit us to learn more. ',
          title: 'Student Scholarship | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'rgi-scholarship', component: RgiScholarshipComponent,
        data: {
          title: 'Rgi Scholarship | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'admission-helpline', component: AdmissionHelplineComponent,
        data: {
          description: 'Get admission at GH Raisoni College of Arts, Commerce & Science. Contact our helpline for guidance and support. Start your journey now!',
          title: 'Admisson helpline | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'faq', component: FaqComponent,
        data: {
          description: 'Get answers to questions about GH Raisoni College of Arts, Commerce, and Science. Explore our FAQ section for more information.',
          title: 'FAQ | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'fees-structure', component: FeesStructureComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Sciences detailed fee structure for all courses. Find transparent and comprehensive fee details here.',
          title: 'Fees Structure | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'online-fees-payment', component: OnlineFeesPaymentComponent,
        data: {
          description: 'Securely pay your fees online at GH Raisoni College of Arts, Commerce, and Science. Easy, fast, and convenient fee payment options available.',
          title: 'Online fees Payment | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-business-administration-computer-application', component: UgBachelorOfBusinessAdministrationComputerApplicationComponent,
        data: {
          title: 'Bachelor Of Business Administration in Computer Application | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-business-administration', component: UgBachelorOfBusinessAdministrationComponent,
        data: {
          title: 'Bachelor Of Business Administration | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-science-computer-sciencen', component: UgBachelorOfScienceComputerSciencenComponent,
        data: {
          title: 'BSc Computer Science | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-commerce', component: UgBachelorOfCommerceComponent,
        data: {
          title: 'Bachelor of Commerce | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-arts', component: UgBachelorOfArtsComponent,
        data: {
          title: 'Bachelor of Arts | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-science', component: UgBachelorOfScienceComponent,
        data: {
          title: 'Bachelor of Science | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-bachelor-of-science-hospitality-studies', component: UgBachelorOfScienceHospitalityStudiesComponent,
        data: {
          title: 'Bachelor of Science | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'pg-masters-of-science-computer-science', component: PgMastersOfScienceComputerScienceComponent,
        data: {
          title: 'Masters in Science( Computer Science) | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'pg-masters-of-commerce', component: PgMastersOfCommerceComponent,
        data: {
          title: 'Masters in Commerce | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'academic-calender', component: AcademicCalenderComponent,
        data: {
          description: 'Stay updated with GH Raisoni College of Arts, Commerce, and Sciences academic calendar. Find key dates and events for the academic year.',
          title: 'Academic Calender | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'code-of-ethics', component: CodeOfEthicsComponent,
        data: {
          description: 'Explore the Code of Ethics at GH Raisoni College of Arts, Commerce, and Science, fostering integrity and excellence in education.',
          title: 'Code of Ethics | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'feedback-process', component: FeedbackProcessComponent,
        data: {
          description: 'Discover the streamlined feedback process at GH Raisoni College of Arts, Commerce, and Science. Share your thoughts to help us improve!',
          title: 'Feedback Process | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'director-message', component: DirectorMessageComponent,
        data: {
          description: '',
          title: 'Director Message | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'student-projects', component: StudentProjectsComponent,
        data: {
          description: 'Explore innovative student projects at GH Raisoni College of Arts, Commerce, and Science. See inspiring work in various fields. Discover more!',
          title: 'Student projects | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'question-paper', component: QuestionPaperComponent,
        data: {
          description: 'Explore past exam papers and improve your preparation with GH Raisoni College of Arts, Commerce, and Sciences comprehensive question paper archive.',
          title: 'Question Paper | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'grievance-registration-form', component: GrievanceRegistrationFormComponent,
        data: {
          description: 'Submit your grievance easily with GH Raisoni College of Arts, Commerce, and Sciences online registration form. Quick, simple process. Register now!',
          title: 'Grievance Registration Form | GHRCACS Pune'
        }
      },
      {
        path: 'minority-cell-committee', component: MinorityCellCommitteeComponent,
        data: {
          description: '',
          title: 'Minority Cell Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'anti-ragging-committee', component: AntiRaggingCommitteeComponent,
        data: {
          description: 'Discover GH Raisoni College of Arts, Commerce and Science, Pune Anti-Ragging Committee. Commitment to a safe, respectful campus environment.',
          title: 'Anti Ragging Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'college-development-committee', component: CollegeDevelopmentCommitteeComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Sciences College Development Committee. Learn about our strategic vision and initiatives.',
          title: 'College Devlopment Committee | GHRCACS Pune'
        }
      },
      {
        path: 'grievance-redressal-committee', component: GrievanceRedressalCommitteeComponent,
        data: {
          description: 'Learn about our Grievance Redressal Committee at GH Raisoni College of Arts, Commerce, and Science. Ensuring fairness and transparency.',
          title: 'grievance redressal Committee | GHRCACS Pune'
        }
      },
      {
        path: 'exam-grievance-redressal-committee', component: ExamGrievanceRedressalCommitteeComponent,
        data: {
          description: '',
          title: 'Exam Grievance Redressal Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'nss-committee', component: NssCommitteeComponent,
        data: {
          description: '',
          title: 'NSS Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'naac-committee', component: NaacCommitteeComponent,
        data: {
          description: '',
          title: 'NAAC Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'obc-cell-committee', component: ObcCellCommitteeComponent,
        data: {
          description: '',
          title: 'OBC Cell Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'sc-st-committee', component: ScStCommitteeComponent,
        data: {
          description: '',
          title: 'SC ST Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'sports-cultural-committee', component: SportsCulturalCommitteeComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Sciences vibrant sports and cultural committee activities. Engage and thrive with us!',
          title: 'Sports Cultural Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'student-council-committee', component: StudentCouncilCommitteeComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Sciences student council committee roles and responsibilities. Get involved in campus leadership today!',
          title: 'Student Council Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'training-placement-committee', component: TrainingPlacementCommitteeComponent,
        data: {
          description: 'Discover the Training & Placement Committee at GH Raisoni College, empowering students for successful careers. Learn more!',
          title: 'Training Placement Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'womens-grievance-redressal-committee', component: WomensGrievanceRedressalCommitteeComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Science Womens Grievance Redressal Committee. Ensuring a supportive environment for all.',
          title: 'Women grievance redressal Committee | GHRCACS Pune'
        }
      },
      {
        path: 'placement-process', component: PlacementProcessComponent,
        data: {
          description: 'Explore our streamlined placement process at GH Raisoni College of Arts, Commerce and Science, Pune ensuring career success for our students.',
          title: 'Placement process | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'placement-team', component: PlacementTeamComponent,
        data: {
          description: 'Meet our dedicated placement team at GH Raisoni College of Arts, Commerce, and Science, committed to shaping your career success',
          title: 'Placement Team | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'internship', component: InternshipComponent,
        data: {
          description: 'Explore internship opportunities at GH Raisoni College of Arts, Commerce and Science Pune. Gain practical experience to enhance your career prospects.',
          title: 'Internship | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'past-recruiters', component: PastRecruitersComponent,
        data: {
          description: 'Explore past recruiters at GH Raisoni College of Arts, Commerce, and Science. Discover career opportunities and alumni success stories',
          title: 'Past Recruiters | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'testimonials', component: TestimonialsComponent,
        data: {
          description: 'Explore heartfelt testimonials from our students and alumni at GH Raisoni College of Arts, Commerce and Science Pune. Discover their success stories!',
          title: 'Testimonials | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'rocs', component: RocsComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce & Science (GHRCACS) website for courses, admissions, and campus life details. Discover more now!',
          title: 'ROCS | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'about-iqac', component: AboutIqacComponent,
        data: {
          description: 'Learn about IQAC at GHRCE, fostering quality initiatives in higher education, promoting excellence and continuous improvement.',
          title: 'About IQAC | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'objectives', component: ObjectivesComponent,
        data: {
          description: 'Discover the objectives of GHRCACS, dedicated to fostering academic excellence and professional growth in healthcare and research fields.',
          title: 'Objectives | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'functions', component: FunctionsComponent,
        data: {
          description: '',
          title: 'Functions | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'iqac-members', component: IqacMembersComponent,
        data: {
          description: 'Meet the dedicated members of IQAC at GHRCACS, driving academic excellence and quality assurance in education. Explore their roles and expertise!',
          title: 'IQAC Members | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'minutes-of-meeting', component: MinutesOfMeetingComponent,
        data: {
          description: 'Explore comprehensive minutes of meetings from GHRCACS for insights into decisions, actions, and discussions shaping organizational strategies.',
          title: 'Minutes of Meeting | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'atr', component: AtrComponent,
        data: {
          description: '',
          title: 'ATR | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'documents', component: DocumentsComponent,
        data: {
          description: '',
          title: 'Documents | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'naac', component: NaacComponent,
        data: {
          description: '',
          title: 'Naac | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'po-co', component: PoCoComponent,
        data: {
          description: 'Explore GHRCACS Po-Co program offering comprehensive industry-oriented education for aspiring professionals. Learn more today!',
          title: 'PO & CO | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'course-outcomes', component: CourseOutcomesComponent,
        data: {
          description: 'Explore GHRCACS course outcomes, ensuring quality education in computing through measurable learning objectives and student achievement.',
          title: 'Course Outcomes | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'hostel', component: HostelComponent,
        data: {
          description: 'Discover comfortable and secure student accommodations at GHRCACS Hostel. Modern amenities, vibrant community, and a home away from home.',
          title: 'Hostel | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'student-life', component: StudentLifeComponent,
        data: {
          description: '',
          title: 'Student Life | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'events', component: EventsComponent,
        data: {
          description: 'Stay updated with the latest events, workshops, and seminars at GHRCACS. Explore upcoming activities that enhance your learning and growth.',
          title: 'Events | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'atheletics-sports', component: AtheleticsSportsComponent,
        data: {
          description: '',
          title: 'Atheletics Sports | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'library', component: LibraryComponent,
        data: {
          description: 'Explore the GHRCACS library for a vast collection of books, journals, and digital resources. Enhance your knowledge and academic success.',
          title: 'Library | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'labs', component: LabsComponent,
        data: {
          description: 'Explore cutting-edge labs at GHRCACS Raisoni, offering hands-on learning in technology, innovation, and research excellence',
          title: 'Labs | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'kimba', component: KimbaComponent,
        data: {
          description: '',
          title: 'Kimba | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'city-office', component: CityOfficeComponent,
        data: {
          description: '',
          title: 'City Office | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'online-anti-ragging-affidavits', component: OnlineAntiRaggingAffidavitsComponent,
        data: {
          description: 'Complete your online anti-ragging affidavit hassle-free with GH Raisoni College of Arts, Commerce, and Science Pune. Ensure a safe campus environment today!',
          title: 'Online Anti Ragging Affidavits | GHRCACS Pune'
        }
      },
      {
        path: 'aqar', component: AqarComponent,
        data: {
          description: 'Explore GHRCACS Pune Annual Quality Assurance Report (AQAR) showcasing institutional performance and achievements. Learn more today!',
          title: 'AQAR | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'ict-tools', component: IctToolsComponent,
        data: {
          description: 'Explore innovative ICT tools at GHRCACS, enhancing learning and research capabilities for students and professionals in diverse fields.',
          title: 'ICT Tools | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'contact', component: ContactComponent,
        data: {
          description: 'Contact us at GHRCACS for inquiries about our services and programs. Reach out today for expert guidance and support.',
          title: 'Contact | G H Raisoni College of arts, commerce and science, Pune '
        }
      },
      {
        path: 'thank-you', component: ThankYouComponent,
        data: {
          description: '',
          title: 'Thank You | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'login', component: LoginComponent,
        data: {
          description: '',
          title: 'Login | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'bba-entrance', component: BbaEntranceComponent,
        data: {
          description: '',
          title: 'BBA Entrance Exam | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'exam-grievance', component: ExamGrievanceComponent,
        data: {
          description: 'Resolve exam grievances efficiently with GHRCACS. Submit, track, and manage complaints online. Your voice matters in academic fairness.',
          title: 'Exam Grievance | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'admission-cell-committee', component: AdmissionCellCommitteeComponent,
        data: {
          description: 'Meet our dedicated Admission Cell Committee at GH Raisoni College of Arts, Commerce and Science, Pune. Learn about their roles and contributions today!',
          title: 'Admission Cell Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'planning-evaluation-committee', component: PlanningEvaluationCommitteeComponent,
        data: {
          description: 'Discover the role and functions of the Planning & Evaluation Committee at GH Raisoni College of Arts, Commerce, and Science. Learn more today!',
          title: 'Planning Evaliation Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'academic-monitoring-discipline-committee', component: AcademicMonitoringDisciplineCommitteeComponent,
        data: {
          description: 'Learn about GH Raisoni College of Arts, Commerce, and Sciences Academic Monitoring & Discipline Committee. Ensuring academic integrity and student welfare.',
          title: 'Academic Monitoring Discipline Committee | GHRCACS Pune'
        }
      },
      {
        path: 'examination-committee', component: ExaminationCommitteeComponent,
        data: {
          description: 'Meet our diligent Examination Committee at GH Raisoni College of Arts, Commerce, and Science, ensuring fair assessments and academic excellence.',
          title: 'Examination Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'research-development-committee', component: ResearchDevelopmentCommitteeComponent,
        data: {
          description: 'Explore GH Raisoni College of Arts, Commerce, and Sciences Research & Development Committee. Learn about our innovative initiatives and academic research.',
          title: 'Research Development Committee | GHRCACS Pune'
        }
      },
      {
        path: 'building-maintenance-purchase-committee', component: BuildingMaintenancePurchaseCommitteeComponent,
        data: {
          description: 'Learn about GH Raisoni Colleges Building Maintenance Purchase Committee. Discover our commitment to efficient infrastructure management.',
          title: 'Building Maintenance Purchase Committee | GHRCACS Pune'
        }
      },
      {
        path: 'blog', component: BlogComponent,
        data: {
          description: 'Explore insightful articles on education, careers, and technology at GHRCACS blog. Stay informed and inspired. Visit now!',
          title: 'Blog | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'why-an-bba-is-best-suited-for-you', component: WhyAnBBAIsBestSuitedForYouComponent,
        data: {
          description: '',
          title: 'Why an BBA Is Best Suited For You | BBA colleges in Pune'
        }
      },
      {
        path: 'why-bsc-computer-science-is-the-best-oriented-course', component: WhyBscComputerScienceIsTheBestOrientedCourseComponent,
        data: {
          description: '',
          title: 'Why B.Sc Computer science is The Best Career-Oriented Course'
        }
      },
      {
        path: '404', component: NotfoundComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'G H Raisoni College of arts, commerce and science, Pune',
          title: '404 - G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'how-to-get-admission-to-B.Com', component: HowToGetAdmissionToBcomComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Still, finding How Can I Get Admission in B.Com? So you can read here all about the admission process, fee structure, and eligibility of top B.Com colleges in Pune.',
          title: 'How to Get Admission in B.Com | Top B.Com college in Pune'
        }
      },
      {
        path: 'Why-did-we-choose-BBA-in-Computer-Applications', component: WhyDidWeChooseBbaInComputerApplicationsComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'As a professional degree, the BBA in computer applications offers its students many opportunities to network with industry professionals.',
          title: 'Why did we choose BBA in Computer Applications | GHRCACS Pune'
        }
      },
      {
        path: 'aqar-tweety', component: TwentyOneComponent,
        data: {
          description: 'Explore GHRCACS AQAR Tweety platform for comprehensive insights and updates on institutional progress and achievements in education.',
          title: 'AQAR Tweety | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'b-sc-in-computer-science', component: BScInComputerScienceComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Gain expertise in programming, algorithms, databases, and software engineering with a B.Sc. in Computer Science. Unlock your potential today!',
          title: 'The Top Skills You will Develop in a B.Sc. in Computer Science | GHRCACS Pune'
        }
      },
      {
        path: 'bachelor-of-commerce-degree', component: BachelorOfCommerceDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the Pros and Cons of a Bachelor of Commerce Degree. Learn if it is the right choice for you. Read our comprehensive guide now.',
          title: 'The Pros and Cons of Pursuing a Bachelor of Commerce Degree | GHRCACS Pune'
        }
      },
      {
        path: 'bachelors-degree-in-business-administration', component: BachelorsDegreeInBusinessAdministrationComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Find out if a bachelors degree in business administration is worth the investment. Learn about career opportunities and earning potential.',
          title: 'Is A Bachelors Degree In Business Administration Worth It? | GHRCACS Pune'
        }
      },
      {
        path: 'bachelor-of-commerce-degree-a-comprehensive-guide', component: BachelorOfCommerceDegreeAComprehensiveGuideComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Find out if a bachelors degree in business administration is worth the investment. Learn about career opportunities and earning potential.',
          title: 'Is A Bachelors Degree In Business Administration Worth It? | GHRCACS Pune'
        }
      },
      {
        path: 'bachelor-of-business-administration-program', component: BachelorOfBusinessAdministrationProgramComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover essential skills gained in a Bachelor of Business Administration program, equipping you for success in diverse businesses.',
          title: 'Skills Acquired in a Bachelor of Business Administration Program | GHRCACS Pune'
        }
      },
      {
        path: 'bachelor-of-business-administration-degree', component: BachelorOfBusinessAdministrationDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the advantages of a Bachelor of Business Administration degree, from versatile skills to increased career opportunities. Learn More!.',
          title: 'Benefits of Pursuing a Bachelor of Business Administration Degree| GHRCACS Pune'
        }
      },
      {
        path: 'why-choose-a-bachelor-of-commerce', component: WhyChooseABachelorOfCommerceComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the advantages of pursuing a Bachelor of Commerce degree. Unlock diverse career opportunities and develop essential business skills.',
          title: 'Why Choose a Bachelor of Commerce: Exploring the Benefits'
        }
      },
      {
        path: 'bachelors-degree-after-twelve-commerce', component: BachelorsDegreeAfterTwelveCommerceComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore a rewarding career path with a Bachelors degree after 12th commerce. Unlock opportunities and excel in the business world!',
          title: 'Bachelor’s degree after 12th commerce worth considering!'
        }
      },
      {
        path: 'bba-computer-applications', component: BbaComputerApplicationsComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore the BBA in Computer Applications: Discover the syllabus, career scope, admission process, top colleges, and salary prospects.',
          title: 'BBA Computer Applications: Syllabus, Scope & Admission'
        }
      },
      {
        path: 'bachelor-of-business-degree', component: BachelorOfBusinessDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the top 10 reasons why a Bachelor of Business degree can unlock endless career opportunities and pave the path to success.',
          title: '10 Reasons to Pursue a Bachelor of Business Degree | GHRCACS, PUNE'
        }
      },
      {
        path: 'bachelor-degree', component: BachelorDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover how obtaining a bachelor degree in commerce can significantly enhance career opportunities for graduates in the field.',
          title: 'Enhancing Commerce Career with a Bachelor Degree | GHRCACS, PUNE'
        }
      },
      {
        path: 'tips-for-commerce-students-pursuing-a-b-com-degree', component: TipsForCommerceStudentsPursuingABComDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the advantages and limitless possibilities of pursuing a Bachelor of Computer Application degree. Unleash your tech potential today!',
          title: 'Essential Tips for Commerce Students Pursuing a B. Com Degree'
        }
      },
      {
        path: 'why-pursue-bachelor-of-computer-application', component: WhyPursueBachelorOfComputerApplicationComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the advantages and limitless possibilities of pursuing a Bachelor of Computer Application degree. Unleash your tech potential today!',
          title: 'Why Pursue Bachelor of Computer Application | GHRCACS, PUNE'
        }
      },

      {
        path: 'scope-of-bba', component: ScopeOfBbaComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore scope of BBA & careers after 12th. Unlock business opportunities with a BBA degree. Start your journey today!',
          title: 'Understanding the Scope of BBA: Career Prospect & Opportunities | GHRCACS, PUNE'
        }
      },
      {
        path: 'bsc-computer-science-course', component: BscComputerScienceCourseComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Boost your BSc Computer Science exam success with expert study tips & strategies. Ace your exams and excel in your studies!',
          title: 'How to Ace Your BSc Computer Science Exams: Study Tips | GHRCACS, PUNE'
        }
      },
      {
        path: 'tips-for-bsc-computer-science-student', component: TipsForBscComputerScienceStudentComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Unlock your potential with top study tips & resources for BSc Computer Science. Ace your degree journey with expert strategies.',
          title: 'Tips for BSc Computer Science Student | GHRCACS, PUNE'
        }
      },

      {
        path: 'advantages-of-bba-degree', component: AdvantagesOfBbaDegreeComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Unlock limitless Advantages of BBA Degree. Build a solid future foundation through practical skills, leadership, and business acumen.',
          title: 'The Advantages of BBA Degree: Your Futures Strong Foundation | GHRCACS, PUNE'
        }
      },
      {
        path: 'bba-in-computer-application', component: BbaInComputerApplicationComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the advantages of a BBA in Computer Application – unlock a world of tech opportunities and career growth!',
          title: 'The Benefits of Pursuing a BBA in Computer Application | GHRCACS, PUNE'
        }
      },
      {
        path: 'best-bba-courses', component: BestBbaCoursesComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover your ideal career journey with our guide to the best BBA courses. Make the right choice for a successful future. Explore now!',
          title: 'Exploring the Best BBA Courses for Your Career | GHRCACS, PUNE'
        }
      },
      {
        path: 'bsc-it', component: BscItComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Bsc It | GHRCACS, PUNE',
          title: 'Bsc It | GHRCACS, PUNE'
        }
      },
      {
        path: 'top-universities-for-bba-programs', component: TopUniversitiesForBbaProgramsComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover the top 5 universities with exceptional BBA programs for a promising business career. Choose your path to success today!',
          title: 'Top 5 Universities Offering the Best BBA Programs | GHRCACS, PUNE'
        }
      },
      {
        path: 'career-options-after-bachelor-of-commerce', component: CareerOptionsAfterBachelorOfCommerceComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Discover lucrative career paths after a Bachelor of Commerce degree. Explore finance, accounting, marketing, and more for a bright future!',
          title: 'Top Career Options after Bachelor of Commerce  | GHRCACS, PUNE'
        }
      },
      {
        path: 'bba-in-computer-apllications', component: BbaInComputerApllicationsComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore exciting job opportunities for BBA Computer Application students and kickstart your career in tech!',
          title: 'Job Opportunities for Students Pursuing BBA in Computer Application | GHRCACS, PUNE'
        }
      },
      {
        path: 'm-com', component: MComComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore exciting job opportunities for BBA Computer Application students and kickstart your career in tech!',
          title: 'Master of Commerce | GHRCACS, PUNE'
        }
      },
      {
        path: 'pg-msc', component: PgMscComponent,
        data: {
          keywords: 'G H Raisoni College of arts, commerce and science, Pune',
          description: 'Explore exciting job opportunities for BBA Computer Application students and kickstart your career in tech!',
          title: 'Master of Science | GHRCACS, PUNE'
        }
      },
      {
        path: 'twentytwo-twentythree', component: TwentytwoTwentythreeComponent,
        data: {
          description: 'Twentytwo twentythree | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Twentytwo twentythree | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'bsc-Information-technology', component: BscItComponent,
        data: {
          description: 'B.Sc Information Technology | G H Raisoni College of arts, commerce and science, Pune',
          title: 'B.Sc Information Technology | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'bba-international-business', component: BbaInternationalBusinessComponent,
        data: {
          description: 'BBA international Business | G H Raisoni College of arts, commerce and science, Pune',
          title: 'BBA international Business | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'msc-computer-science', component: MscComputerScienceComponent,
        data: {
          description: 'M.Sc Computer Science | G H Raisoni College of arts, commerce and science, Pune',
          title: 'M.Sc Computer Science | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'bsc-computer-aplication', component: BscComputerAplicationComponent,
        data: {
          description: 'B.Sc Computer Aplication | G H Raisoni College of arts, commerce and science, Pune',
          title: 'B.Sc Computer Aplication | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'recruters-course', component: RecrutersCourseComponent,
        data: {
          description: 'B.Sc Computer Aplication | G H Raisoni College of arts, commerce and science, Pune',
          title: 'B.Sc Computer Aplication | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'exam-circulars', component: ExamCircularsComponent,
        data: {
          description: 'Exam Circulars | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Exam Circulars | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'latest-news', component: LatestNewsComponent,
        data: {
          description: 'Latest News | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Latest News | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'twentythree-twentyfour', component: TwentythreeTwentyfourComponent,
        data: {
          description: 'Twentythree Twentyfour | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Twentythree Twentyfour | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'divyang-committee', component: DivyangCommitteeComponent,
        data: {
          description: 'Divyang Committee | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Divyang Committee | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'students-achievement', component: StudentsAchievementComponent,
        data: {
          description: 'Twentythree Twentyfour | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Twentythree Twentyfour | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'popup-modal', component: PopupModalComponent,
        data: {
          description: 'Popup Modal | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Popup Modal | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'women-empowerment', component: WomenEmpowermentComponent,
        data: {
          description: 'Women Empowerment | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Women Empowerment | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'guru-purnima', component: GuruPurnimaComponent,
        data: {
          description: 'Guru Purnima | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Guru Purnima | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ashadhi-ekadashi', component: AshadhiEkadashiComponent,
        data: {
          description: 'Ashadhi Ekadashi | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Ashadhi Ekadashi | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'sanskrutik-mohotsav', component: SanskrutikMohotsavComponent,
        data: {
          description: 'Sanskrutik Mohotsav| G H Raisoni College of arts, commerce and science, Pune',
          title: 'Sanskrutik Mohotsav| G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'shivaji-maharaj-jayanti', component: ShivajiMaharajJayantiComponent,
        data: {
          description: 'Shivaji Maharaj| G H Raisoni College of arts, commerce and science, Pune',
          title: 'Shivaji Maharaj| G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'marathi-rajbhasha', component: MarathiRajbhashaComponent,
        data: {
          description: 'Marathi Rajbhasha| G H Raisoni College of arts, commerce and science, Pune',
          title: 'Marathi Rajbhasha| G H Raisoni College of arts, commerce and science, Pune'
        }
      },

      {
        path: 'antaragni', component: AntaragniComponent,
        data: {
          description: 'Antaragni| G H Raisoni College of arts, commerce and science, Pune',
          title: 'Antaragni| G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'annual-prize-distribution', component: AnnualPrizeDistributionComponent,
        data: {
          description: 'Annual Prize Distribution | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Annual Prize Distribution | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'punyatithi-of-annabhau-sathe', component: PunyatithiOfAnnabhauSatheComponent,
        data: {
          description: 'Punyatithi Of Annabhau Sathe | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Punyatithi Of Annabhau Sathe | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'induction-program', component: InductionProgramComponent,
        data: {
          description: 'Induction Program | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Induction Program | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'founders-day', component: FoundersDayComponent,
        data: {
          description: 'Founders Day | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Founders Day | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'celebrating-yoga-day', component: CelebratingYogaDayComponent,
        data: {
          description: 'Celebrating Yoga Day | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Celebrating Yoga Day | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'nss-camp', component: NssCampComponent,
        data: {
          description: 'NSS Camp | G H Raisoni College of arts, commerce and science, Pune',
          title: 'NSS Camp | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'gb-meeting', component: GbMeetingComponent,
        data: {
          description: 'GB Meeting | G H Raisoni College of arts, commerce and science, Pune',
          title: 'GB Meeting | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'science-day', component: ScienceDayComponent,
        data: {
          description: 'Science Day | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Science Day | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'coderush', component: CoderushComponent,
        data: {
          description: 'CodeRush | G H Raisoni College of arts, commerce and science, Pune',
          title: 'CodeRush | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'industry-connect', component: IndustryConnectComponent,
        data: {
          description: 'Industry Connect | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Industry Connect | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'business-expo', component: BusinessExpoComponent,
        data: {
          description: 'Business Expo | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Business Expo | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'cynosure-toastmasters', component: CynosureToastmastersComponent,
        data: {
          description: 'Business Expo | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Business Expo | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'guest-lecturer', component: GuestLecturerComponent,
        data: {
          description: 'Guest Lecture | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Guest Lecture | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'digital-marketing-workshop', component: DigitalMarketingWorkshopComponent,
        data: {
          description: 'Digital Marketing Workshop | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Digital Marketing Workshop | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'anti-ragging-event', component: AntiRaggingEventComponent,
        data: {
          description: 'Anti Ragging Event | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Anti Ragging Event | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'ug-programs', component: UgProgramsComponent,
        data: {
          description: 'UG Programs | G H Raisoni College of arts, commerce and science, Pune',
          title: 'UG Programs | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'pg-programs', component: PgProgramsComponent,
        data: {
          description: 'PG Programs | G H Raisoni College of arts, commerce and science, Pune',
          title: 'PG Programs | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'eligibility-intake', component: EligibilityIntakeComponent,
        data: {
          description: 'Eligibility Intake | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Eligibility Intake | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      {
        path: 'farewell-party', component: FarewellPartyComponent,
        data: {
          description: 'Farewell Party | G H Raisoni College of arts, commerce and science, Pune',
          title: 'Farewell Party | G H Raisoni College of arts, commerce and science, Pune'
        }
      },
      { path: '**', redirectTo: '/404' }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
